<a class="col text-decoration-none" routerLink="guests/accommodation">
    <div class="accommodation-btn d-flex align-items-center justify-content-between w-100 border-card">
        <div class="d-inline-flex flex-row gap-2 align-items-center">
            <span class="text-label">View Accommodation</span>
            <span class="badge-pill">Exclusive</span>
        </div>
        <div class="arrow-icon-wrapper ">
            <span class="arrow-icon">&#8594;</span>
        </div>
    </div>
</a>